import { useState } from "react";
// css
import "./SiginInPopup.css";
// others
import messageIcon from "assets/Images/icons/Message.svg";
import passwordIcon from "assets/Images/icons/Password.svg";
// import googleIcon from "assets/Images/icons/google-icon.svg";
// import fbIcon from "assets/Images/icons/fb-icon.svg";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNotifyContext } from "context/notifyContext"
import {check_current_user} from "store/actions"
import {connect} from "react-redux"

//================ THIS IS A SIGN IN COMPONENT =======================
// api endpoints =================
let api_auth = process.env.REACT_APP_USER_AUTH;


// 
const SiginInPopup = (props) => {
  //===================== notification alerts ==================
  const { set_notify,set_loader,loading } = useNotifyContext();
  //=========== form data states ===============
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  //============== Handle form detail on change ====================
  const handleFormDetails = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  }

  // ================== sign in to account  ========================
  const SignInToAccount = (e) => {
    e.preventDefault();
    set_loader(true)
    axios({
      method: "POST",
      url: api_auth,
      headers: {
        'Accept': 'application/json',
        'Content-Type': "application/json; charset=utf-8" // "text/html; charset=UTF-8",
      },
      data: {
        "email": formData.email,
        "password": formData.password,
      },
    }).then((response) => {
      let data = response?.data;
      if (data.status !== "error") {
        set_loader(false);
        set_notify({ open: true, msg: "Sign In Successfully.", type: "success" })
     
        setFormData({
          email: "",
          password: ""
        });
        props.closeModel(false);
        localStorage.setItem("cyan_user", JSON.stringify(data.token));
        props.check_current_user(data.token)
        // console.log(response)
        // console.log(data)
      } else {
        set_loader(false);
        set_notify({ open: true, msg: data?.['error-message'], type: "error" })
        console.log("Error about sign in to user ====>", data);
      }
    }).catch((err) => {
      set_loader(false);
      set_notify({ open: true, msg: err.message, type: "error" })
      console.log("Error about sign in to  user ====>", err.message);
    })
  }

  return (
    <>
      <div className="siginin_popup">
        <h2 className="my-3">Welcome back again!</h2>
        <form
          onSubmit={SignInToAccount}
          className="siginin_form">
          <div className="input_div">
            <img src={messageIcon} alt="..." />
            <input onChange={handleFormDetails} value={formData.email} name="email" type="text" placeholder="Email" />
          </div>
          <div className="input_div">
            <img src={passwordIcon} alt="..." />
            <input onChange={handleFormDetails} value={formData.password} name="password" type="password" placeholder="Password" />
          </div>
          <button
            disabled={formData?.email.length > 5 && formData.password.length > 4 ? loading : true}
            type="submit"
            className="siginin_form_btn mt-2 mb-2">Sign in</button>
          <p>
            {/* <b>Forgot</b> your password? */}
          </p>
          {/* <div className="or_line">
            <hr />
            <span>OR</span>
            <hr />
          </div> */}
        </form>
        <div className="auth">
          {/* <button className="auth_btn">
            <img src={googleIcon} alt="..." />&nbsp;&nbsp;&nbsp;
            <span>Continue with Google</span>
          </button>
          <button className="auth_btn">
            <img src={fbIcon} alt="..." />
            <span>Continue with Facebook</span>
          </button> */}
          <p>
            Don't have an account? <Link onClick={() => props.closeModel(false)} className="text-sec px-2" to="/signup">Sign Up</Link>
          </p>
        </div>
      </div>
    </>
  );
};


// redux configs
const mapDispatchToProps = (dispatch) => ({
  check_current_user: (token) => dispatch(check_current_user(token)),
});

export default connect(null, mapDispatchToProps)(SiginInPopup);
